import { useEffect, useRef } from 'react';
import gsap from 'gsap';

export function useContactGsapAnimation() {
  const formRef = useRef(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const form = formRef.current;
    const header = headerRef.current;
    if (!form || !header) return;

    gsap.set([header, form], { opacity: 0, y: 80 });

    const onScroll = () => {
      const trigger = form.getBoundingClientRect().top < window.innerHeight * 0.8;
      if (trigger) {
        gsap.to(header, { opacity: 1, y: 0, duration: 1, ease: 'power3.out' });
        gsap.to(form, { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out', delay: 0.2 });
        window.removeEventListener('scroll', onScroll);
      }
    };
    window.addEventListener('scroll', onScroll);
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return { formRef, headerRef };
}
